var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_630_19367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.43341 2.26629L4.95341 6.31962C4.68008 6.75962 5.00008 7.33296 5.52008 7.33296H10.4734C10.9934 7.33296 11.3134 6.75962 11.0401 6.31962L8.56675 2.26629C8.30675 1.83962 7.69341 1.83962 7.43341 2.26629Z",
    fill: "#1E4133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.667 14.667C13.3238 14.667 14.667 13.3238 14.667 11.667C14.667 10.0101 13.3238 8.66699 11.667 8.66699C10.0101 8.66699 8.66699 10.0101 8.66699 11.667C8.66699 13.3238 10.0101 14.667 11.667 14.667Z",
    fill: "#1E4133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 14.3333H6.66667C7.03333 14.3333 7.33333 14.0333 7.33333 13.6667V9.66667C7.33333 9.3 7.03333 9 6.66667 9H2.66667C2.3 9 2 9.3 2 9.66667V13.6667C2 14.0333 2.3 14.3333 2.66667 14.3333Z",
    fill: "#1E4133"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_630_19367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.1ed656473d58596664240b8494e6f39f.svg";
export { ForwardRef as ReactComponent };